import {
  SET_EMAIL_FOR_SHARED_AUTH,
  SET_ROLES_FOR_SHARED_AUTH,
  SET_PERMISSIONS_FOR_SHARED_AUTH,
  SET_DISPLAY_NAME_FOR_SHARED_AUTH,
  SET_PROFILE_VALIDATIONS_FOR_SHARED_AUTH,
  SET_DOB_FOR_SHARED_AUTH,
  SET_GROUP_NAME_FOR_SHARED_AUTH,
  SET_IS_ALLOWED_FOR_SHARED_AUTH,
  SET_IS_VALID_TYPE_FOR_SHARED_AUTH,
  SET_MAINTENANCE_MESSAGE,
  SET_LOGIN_ATTEMPTED
} from './constants';

export const setEmailInState = email => ({
  type: SET_EMAIL_FOR_SHARED_AUTH,
  payload: email
});

export const setRoleForUserInState = roles => ({
  type: SET_ROLES_FOR_SHARED_AUTH,
  payload: roles
});

export const setPermissionForUserInState = permissions => ({
  type: SET_PERMISSIONS_FOR_SHARED_AUTH,
  payload: permissions
});

export const setDisplayNameInState = userProfile => ({
  type: SET_DISPLAY_NAME_FOR_SHARED_AUTH,
  payload: userProfile
});

export const setProfileValidationsInState = userProfile => ({
  type: SET_PROFILE_VALIDATIONS_FOR_SHARED_AUTH,
  payload: userProfile
});

export const setDobInState = dob => ({
  type: SET_DOB_FOR_SHARED_AUTH,
  payload: dob
});

export const setIsAllowedInState = isAllowed => ({
  type: SET_IS_ALLOWED_FOR_SHARED_AUTH,
  payload: isAllowed
});

export const setIsValidTypeInState = isValidType => ({
  type: SET_IS_VALID_TYPE_FOR_SHARED_AUTH,
  payload: isValidType
});

export const setGroupNameInState = groupName => ({
  type: SET_GROUP_NAME_FOR_SHARED_AUTH,
  payload: groupName
});

export const setMaintenanceMessage = payload => ({
  type: SET_MAINTENANCE_MESSAGE,
  payload: payload
});

export const setLoginAttempted = () => ({
  type: SET_LOGIN_ATTEMPTED,
  payload: { loginAttempted: true }
});



// WEBPACK FOOTER //
// ./src/features/shared/auth/actionTypes.js